module.exports = __webpack_public_path__ + "static/media/404.40fa2ab5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.svg
// module id = 807
// module chunks = 7